import React from "react";

/** Looping marquee strip. Colors via props. */
export default function MarqueeStrip({
  items = ["BON SANG !", "INTIMITÉ SANS TABOUS", "JARDIN INTIME", "CHUT ! ON TESTE"],
  bg = "#0A8074",
  color = "#FFD01E",
  reverse = false,
  slow = false,
  border = true,
}) {
  const trackClass = `marquee-track ${slow ? "marquee-track--slow" : ""} ${reverse ? "marquee-track--reverse" : ""}`;
  return (
    <div
      data-testid="marquee-strip"
      className={`overflow-hidden ${border ? "border-y-2 border-black" : ""}`}
      style={{ background: bg, color }}
    >
      <div className={trackClass}>
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center">
            {items.concat(items).map((t, i) => (
              <span
                key={`${k}-${i}`}
                className="font-display-black uppercase text-3xl sm:text-5xl px-6 py-3 whitespace-nowrap flex items-center gap-6"
              >
                {t}
                <span className="inline-block w-4 h-4 rounded-full bg-current opacity-70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
